module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "newPurchaseOrder"
    }
  }, [_c('el-row', {
    staticClass: "clearfix"
  }, [_c('el-col', {
    staticClass: "fl",
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.backGo()
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fr",
    attrs: {
      "span": 1
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh",
    staticStyle: {
      "font-size": "25px",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  })])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fl searthPart",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('p', {
    staticClass: "headerT"
  }, [_vm._v("采购订单变更信息")]), _vm._v(" "), _c('el-form', {
    ref: "purchaseOrderForm",
    attrs: {
      "model": _vm.purchaseOrderForm,
      "label-width": "120px",
      "label-position": _vm.labelPosition,
      "rules": _vm.purchaseOrderFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单编号",
      "prop": "code"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "订单编号",
      "clearable": ""
    },
    on: {
      "change": _vm.getCode
    },
    model: {
      value: (_vm.purchaseOrderForm.code),
      callback: function($$v) {
        _vm.$set(_vm.purchaseOrderForm, "code", $$v)
      },
      expression: "purchaseOrderForm.code"
    }
  }, _vm._l((_vm.codeList), function(item, index) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.code,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注信息",
      "prop": "memo"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.purchaseOrderForm.memo),
      callback: function($$v) {
        _vm.$set(_vm.purchaseOrderForm, "memo", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "purchaseOrderForm.memo"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "headerT"
  }, [_vm._v("变更内容")]), _vm._v(" "), _c('el-form', {
    ref: "purchaseOrderForm",
    attrs: {
      "model": _vm.purchaseOrderForm,
      "label-width": "120px",
      "label-position": _vm.labelPosition,
      "rules": _vm.purchaseOrderFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "供应商",
      "prop": "supplierName"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择供应商",
      "clearable": ""
    },
    on: {
      "change": _vm.getSupplier
    },
    model: {
      value: (_vm.purchaseOrderForm.supplierName),
      callback: function($$v) {
        _vm.$set(_vm.purchaseOrderForm, "supplierName", $$v)
      },
      expression: "purchaseOrderForm.supplierName"
    }
  }, _vm._l((_vm.supplierList), function(item, index) {
    return _c('el-option', {
      key: item.supplierCode,
      attrs: {
        "label": item.supplierName,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "采购日期",
      "prop": "purchaseTime"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.purchaseOrderForm.purchaseTime),
      callback: function($$v) {
        _vm.$set(_vm.purchaseOrderForm, "purchaseTime", $$v)
      },
      expression: "purchaseOrderForm.purchaseTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预期交货日期",
      "prop": "aogTime"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.purchaseOrderForm.aogTime),
      callback: function($$v) {
        _vm.$set(_vm.purchaseOrderForm, "aogTime", $$v)
      },
      expression: "purchaseOrderForm.aogTime"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "fr",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('p', {
    staticClass: "headerT fl"
  }, [_vm._v("订单详情")]), _vm._v(" "), _c('el-button', {
    staticClass: "fr",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "size": "small",
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.newMater()
      }
    }
  }, [_vm._v("新建明细")]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card fr",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.returnData,
      "border": "",
      "header-cell-style": {
        'text-align': 'center'
      },
      "summary-method": _vm.getSummaries,
      "show-summary": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "index",
      "width": "50",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteRow(scope.$index, _vm.returnData)
            }
          }
        }, [_vm._v("移除")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialCode",
      "label": "物料编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "materialName",
      "label": "物料名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "number",
      "label": "采购数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "price",
      "formatter": _vm.addCommas,
      "label": "采购单价(元)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "amount",
      "formatter": _vm.addCommas,
      "label": "合计金额"
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新建物料信息",
      "visible": _vm.dislogMater,
      "close-on-click-modal": false,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dislogMater = $event
      },
      "close": function($event) {
        return _vm.emptyDialog('materForm')
      }
    }
  }, [_c('el-form', {
    ref: "materForm",
    attrs: {
      "model": _vm.materForm,
      "label-width": "100px",
      "label-position": _vm.labelPosition,
      "rules": _vm.materFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "物料编号：",
      "prop": "materialCoding"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择物料编号"
    },
    on: {
      "change": _vm.changeMethods
    },
    model: {
      value: (_vm.materForm.materialCoding),
      callback: function($$v) {
        _vm.$set(_vm.materForm, "materialCoding", $$v)
      },
      expression: "materForm.materialCoding"
    }
  }, _vm._l((_vm.materNumberList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.materialCode,
        "value": item.materialCoding,
        "clearable": ""
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "物料名称：",
      "prop": "materialName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.materForm.materialName),
      callback: function($$v) {
        _vm.$set(_vm.materForm, "materialName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "materForm.materialName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "采购数量：",
      "prop": "number"
    }
  }, [
    [_c('el-input-number', {
      attrs: {
        "min": 1
      },
      model: {
        value: (_vm.materForm.number),
        callback: function($$v) {
          _vm.$set(_vm.materForm, "number", (typeof $$v === 'string' ? $$v.trim() : $$v))
        },
        expression: "materForm.number"
      }
    })]
  ], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "采购单价：",
      "prop": "price"
    }
  }, [_c('el-input', {
    on: {
      "blur": function($event) {
        return _vm.toThousands(_vm.materForm.price)
      }
    },
    model: {
      value: (_vm.materForm.price),
      callback: function($$v) {
        _vm.$set(_vm.materForm, "price", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "materForm.price"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.addEventFormSubmitBtn('materForm')
      }
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.emptyDialog('materForm')
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('el-dropdown', {
    staticClass: "fr",
    staticStyle: {
      "margin": "50px 0"
    },
    attrs: {
      "split-button": "",
      "type": "primary",
      "trigger": "click"
    }
  }, [_vm._v("提交为\n            "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.DetermineSave()
      }
    }
  }, [_vm._v("已确认")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.temporarySave()
      }
    }
  }, [_vm._v("暂存")])], 1)], 1), _vm._v(" "), _c('el-dropdown', {
    staticClass: "fr",
    staticStyle: {
      "margin": "50px 20px 50px 0"
    },
    attrs: {
      "split-button": "",
      "type": "primary",
      "trigger": "click"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.pageStatus) + "\n            "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.goOnSave()
      }
    }
  }, [_vm._v("留在当前页面")]), _vm._v(" "), _c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.closeSave()
      }
    }
  }, [_vm._v("离开当前页面")])], 1)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fr",
    staticStyle: {
      "margin": "50px 20px 50px 0"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cancelOrder()
      }
    }
  }, [_vm._v("取消新建")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-19fb5dc7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/purchaseManage/newPurchaseOrderChangeOrder.vue
// module id = 1602
// module chunks = 0